import { css } from '@emotion/react';
import {
  ButtonComponent, ButtonSize, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { Stack } from '~/_shared/baseComponents/layout/stack.component';
import { useTranslation } from '~/_shared/utils/hooks';
import googleLogo from '../../../../../../resources/assets/images/3rdPartyLogos/google-logo.svg';
import msLogo from '../../../../../../resources/assets/images/3rdPartyLogos/ms-logo.svg';

const ssoButtonStyle = css({
  fontSize: 20,
  width: '100%',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 500,
  backgroundColor: '#131314',
  border: '1px solid #8E918F',
  '&:hover': {
    backgroundColor: '#111B22',
  },
});

const ssoButtonContentStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  fontSize: 18,
  fontWeight: 400,
});

const ssoLogoStyle = css({
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const SsoButtonsComponent = ({
  isDisabled,
  onGoogleLogin,
  onMicrosoftLogin,
}: {
  isDisabled?: boolean;
  onGoogleLogin?: () => void;
  onMicrosoftLogin?: () => void;
}) => {
  const [t] = useTranslation();

  return (
    <Stack gap={16}>
      <ButtonComponent
        buttonStyle={ButtonStyle.Custom}
        css={ssoButtonStyle}
        size={ButtonSize.Large}
        isDisabled={isDisabled}
        onClick={onGoogleLogin}
        text={(
          <div css={ssoButtonContentStyle}>
            <img
              src={googleLogo}
              alt="Google"
              css={ssoLogoStyle}
            />
            {t('Continue with {{provider}}', { provider: 'Google' })}
          </div>
        )}
      />
      <ButtonComponent
        buttonStyle={ButtonStyle.Custom}
        css={ssoButtonStyle}
        size={ButtonSize.Large}
        isDisabled={isDisabled}
        onClick={onMicrosoftLogin}
        text={(
          <div css={ssoButtonContentStyle}>
            <img
              src={msLogo}
              alt="Microsoft"
              css={ssoLogoStyle}
            />
            {t('Continue with {{provider}}', { provider: 'Microsoft' })}
          </div>
        )}
      />
    </Stack>
  );
};
